import { render, staticRenderFns } from "./template8.vue?vue&type=template&id=44e6d54d&scoped=true"
import script from "./template8.vue?vue&type=script&lang=js"
export * from "./template8.vue?vue&type=script&lang=js"
import style0 from "./template8.vue?vue&type=style&index=0&id=44e6d54d&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44e6d54d",
  null
  
)

export default component.exports